import { render, staticRenderFns } from "./certificate-editor.vue?vue&type=template&id=61c70c85"
import script from "./certificate-editor.vue?vue&type=script&lang=ts"
export * from "./certificate-editor.vue?vue&type=script&lang=ts"
import style0 from "./certificate-editor.vue?vue&type=style&index=0&id=61c70c85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports